import makeUrl from "../common/utils/UrlMaker";

function getContactHTML(name, lang, type = "html") {
  return fetch(
    makeUrl("ebokContactServiceUrl", `/${lang}/${name}.${type}`),
    {
      Accept:
        "text/html"
    }
  ).then((response) => {
    if (response.headers.get("Content-Type").includes("html")) {
      return response.text();
    } else {
      return null;
    }
  });
}
export const ebokContactService = {
  getContactHTML
};
